import type { PreparedItemsDraftResponse } from "@/features/prepared-items/types/preparedItems.draft,types";
import type { HelperDataResponse } from "@/features/prepared-items/types/preparedItems.types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";


interface PreparedItemsState {
  helperData: HelperDataResponse | null;
  isHelperDataLoaded: boolean;
  draft: PreparedItemsDraftResponse| null;
  draftId: string | null;
}

const initialState: PreparedItemsState = {
  helperData: null,
  isHelperDataLoaded: false,
  draft: null,
  draftId: null,
};

const preparedItemsSlice = createSlice({
  name: "preparedItems",
  initialState,
  reducers: {
    setHelperData: (state, action: PayloadAction<HelperDataResponse>) => {
      state.helperData = action.payload;
      state.isHelperDataLoaded = true;
    },
    clearHelperData: (state) => {
      state.helperData = null;
      state.isHelperDataLoaded = false;
    },
    setDraft: (state, action: PayloadAction<PreparedItemsDraftResponse>) => {
      state.draft = action.payload;
    },
    clearDraft: (state) => {
      state.draft = null;
    },
    clearDraftId: (state) => {
      state.draftId = null;
    },
    setDraftId: (state, action: PayloadAction<string>) => {
      state.draftId = action.payload;
    },
  },
});

export const {
  setHelperData,
  clearHelperData,
  setDraft,
  clearDraft,
  clearDraftId,
  setDraftId,
} = preparedItemsSlice.actions;

export const preparedItemsReducer = preparedItemsSlice.reducer;

export const selectHelperData = (state: { preparedItems: PreparedItemsState }) =>
  state.preparedItems.helperData;

export const selectIsHelperDataLoaded = (state: { preparedItems: PreparedItemsState }) =>
  state.preparedItems.isHelperDataLoaded;

export const selectDraft = (state: { preparedItems: PreparedItemsState }) =>
  state.preparedItems.draft;

export const selectDraftId = (state: { preparedItems: PreparedItemsState }) =>
  state.preparedItems.draftId;
